import type { IAgentTool } from '../IAgentTool';

export const labelTool: IAgentTool = {
  name: 'label',
  description: 'Add a label display rule with a field template.',
  parameters: {
    type: 'object',
    properties: {
      field: { type: 'string', description: 'Field to use as label template' },
    },
  },
  supportedDiagramTypes: [],
  tier: 'visual',
  category: 'display',

  async execute(params, context) {
    const field = typeof params.field === 'string' ? params.field.trim() : '';
    const ruleId = context.stores.viewRules.addViewRule('label', field ? { name: `Label: ${field}` } : undefined);

    if (field && ruleId) {
      context.stores.viewRules.updateRuleDisplay(ruleId, {
        label: {
          template: `{{${field}}}`,
          position: 'below',
        },
      });
    }

    return {
      success: true,
      summary: field ? `Added label for ${field}.` : 'Added label rule.',
      createdResourceIds: ruleId ? [ruleId] : [],
    };
  },
};
